<template lang="pug">
  .profile-page.page
    .container(
    v-if="managerHasCamps"
    )
      .profile-page__container
        .profile-page__side
          side-nav(
          v-bind:sideNavData="sideNavData"
          )
        router-view

    .container(
    v-else
    )
      .profile-page__container
        error-modal(
        v-if="showModal"
        :text="'К вашей учетной записи не прикреплен лагерь. Обратитесь к администратору.'"
        @close="showModal = false"
        )
        .profile-page__side
          .side-notification(
            v-if="!showModal"
          )
            p.side-notification__text К вашей учетной записи не прикреплен лагерь. Обратитесь к администратору.
        manager-settings

    .page__footer
      main-footer
</template>
<script>

import {mapState} from "vuex";
import SideNav from "@/components/sideNav/SideNav";
import MainFooter from "@/components/footer/Footer";
import ManagerSettings from "./views/settings/ManagerSettings";
import ErrorModal from "../../../components/modals/ErrorModal";

export default {
  name: "ManagerPage",
  components: {
    ErrorModal,
    ManagerSettings,
    SideNav,
    MainFooter
  },
  data() {
    return {
      showModal: false,
      sideNavData: {
        links: [
          {
            path: "/pages/manager/camps",
            text: "Лагерь"
          },
          {
            path: "/pages/manager/shifts",
            text: "Смены"
          },
          {
            path: "/pages/manager/requests",
            text: "Заявки"
          },
          {
            path: "/pages/manager/contract",
            text: "Настройка договора"
          },
          {
            path: "/pages/manager/settings",
            text: "Настройки аккаунта"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState(["userData"]),
    managerHasCamps() {
      if (this.userData.camps.length > 0) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    if (!this.managerHasCamps) {
      this.showModal = true;
    }
  }
};
</script>
